import React, { Component, Suspense } from "react";
import { Button } from "react-bootstrap";
import SiteRender from "../Sites/SiteRender";
import MeteringReport from "../Report/meteringReport";
import AlertSetReport from "../Report/alertSetReport";
import AlarmHistory from "../Report/AlarmHistory/AlarmHistory";
import Report from "../Report/Report";
import CommissionSensor from "../Report/CommissionSensor";
import ConfigSensor from "../Report/ConfigSensor";
import Measure from "../Report/Measure/Measure"
import DeviceHealthPane from "./DeviceHealthPane";
import ReportsPane from "./ReportsPane";
import SitePane from "./SitePane";
import SecondServer from "../database/SecondServer";
import EZNotify from "../Alert/SimplerNotify";
import GrantRequest from "../Grants/RequestDialog";
import { siteAccessCode, sensorConfig, siteGeoCode } from "../database/apiv2SiteAccessor";
import {sensorTypeName, sensorDisplayOrder} from '../Report/Measure/Sensors'
import SitePerms, { permitted } from "./SitePerms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faThLarge, faChevronLeft, faCog, faTools, faTachometerAlt, 
        faExclamationTriangle, faBell, faProjectDiagram, faMapMarkerAlt,
        faSurprise,} from "@fortawesome/free-solid-svg-icons";
import ContactPane from "./ContactPane";
import { readBigConfig, cacheBigConfig, getBigConfig } from '../Sites/SiteConfig';

import { urlGetSite, urlGetKoreStatus, urlGetActiveSubscriptionStatus, urlGetStripeSession, urlGetUserStripeSubscriptions } from "../database/apiUrls";
import Popup from "../Alert/Popup";
import ModalSubscriptionAlert from './ModalSubscriptionAlert';
//import { Analytics } from 'aws-amplify';
import { renderLoader } from "../Loading/loading";
import { eraseTimeRange } from "../Report/Shared/PersistTime";
import {mostRecentPush} from './MostRecent'
import { parseBoolean } from '../Utils/miscRefactors';
import ErrorBoundary from '../ErrorBoundary'
import {getStreetView} from './StreetView'

import "./overview.css";
import "../panels.css";
import "../Sites/SiteList.css";

const VisMapPage = React.lazy(()=>import('../Chart/VisMapPage.js'))

export default class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: "overview",
      viewFilter: undefined,
      pageData: undefined,
      sites: null,
      grantModal: false,
      bannerMsg: "",
      forceUpd: 0,
      isLoading: true,
      loader: renderLoader(),
      needPerms: false,
      isCellModule: false,
      hasActiveSubscription: false,
      userIsSubscriberForThisSite: false,
      subscriptionPastDue: false,
      subscriptionAlert: false,
      modalSubAlertTitle: "",
      modalSubAlertMessage: "",
      modalSubAlertType: 0,
      pushText: undefined,
      btnLabel: "Manage",
      streetView: undefined,
    };
    this.sitePerms = undefined;
    this.mru = undefined
    this.needsConfig = true
    this.streetView = undefined
    this.cancelPoll = new AbortController()
    this.edit = this.edit.bind(this);
    this.changeView = this.changeView.bind(this);
    this.troubleNav = this.troubleNav.bind(this);
    this.changeSite = this.changeSite.bind(this);
    this.specialTZ = this.specialTZ.bind(this);
    this.spaRoute = this.spaRoute.bind(this)
  }

  async componentDidMount() {
    this.props.breadCrumb("overview");
    this.setState({isLoading: true})
    eraseTimeRange()
    this.sitePerms = await SitePerms({ ...this.props });
    const ss = new SecondServer(this.props);
    const site = this.props.getActiveSite();
    const cellNag = await ss.apiData(urlGetKoreStatus(siteAccessCode(site), 'CELL_NAG'))
    //console.log (cellNag)
    if (cellNag?.data?.show && parseBoolean(cellNag.data.show)) {
      this.setState({isCellModule: true, hasActiveSubscription: false})
      this.showModalSubscriptionAlert('Activate Cellular Subscription!',
        'There is NO user currently paying for Cellular Service at this Site. If you would like to continue receiving data, please activate a cellular subscription now!',
        1)
    }
    else {
      const cellButton = await ss.apiData(urlGetKoreStatus(siteAccessCode(site), 'CELL_BUTTON'))
      if (cellButton?.data?.btnText) {
        const active = cellButton.data.btnText.includes("Manage") || cellButton.data?.statusText.startsWith ("Active")
        const subscriber = true
        const late = cellButton.data?.statusText.includes ("Past")
        this.setState({isCellModule: true, hasActiveSubscription: active, userIsSubscriberForThisSite: subscriber,
          subscriptionPastDue : late, pushText: cellButton?.data?.statusText, btnLabel: cellButton.data?.btnText })
      }
      else if (cellButton?.data?.statusText.startsWith('Active')) {
        this.setState({isCellModule: true, hasActiveSubscription: true, userIsSubscriberForThisSite: false,
          subsubscriptionPastDue : false, pushText: cellButton?.data?.statusText, btnLabel: cellButton.data?.btnText, 
        })
      }
      else {
        this.setState({isCellModule: false, hasActiveSubscription: false, pushText: cellButton?.data?.statusText,
          btnLabel: cellButton.data?.btnText,
        })
      }
      console.log (cellButton)
    }
    if (permitted(this.sitePerms)) {
      this.setState({isLoading: false, needPerms: false})
      const config = sensorConfig (this.props.getActiveSite())  // reads cache
      if (!config && this.needsConfig) {
        const url = await getBigConfig(this.props, ss, this.cancelPoll)
        const json = await readBigConfig (url, this.cancelPoll)
        cacheBigConfig(this.props, json)
        if (json) this.needsConfig = false
      } 
      if (!site?.site_details?.utc_offset) {
        const siteinfo = await ss.apiData(urlGetSite(siteAccessCode(site)));
        this.updateTzCache(siteinfo?.data?.data?.utc_offset);
        this.setState({forceUpd: this.state.forceUpd + 1 });
      }
      this.mru = mostRecentPush (site, this.props.userLogin)
      //console.log (this.mru)
    }
    else {
      this.setState({isLoading: false, needPerms: true})
      this.grantModal(true)
    }
    const coords = siteGeoCode(site)
    if (coords) {
      //this.setState({streetView: getStreetView2(coords[0], coords[1])})
      const prom = getStreetView(coords[0], coords[1]) //52.52, 13.405)
      prom.then (result => {
        console.log (result)
        this.setState({streetView: result})
      })
    }
  }
  componentWillUnmount() {
    this.cancelPoll.abort("User cancelled request")
  }

  updateTzCache(tz) {
    this.props.updateSiteListCache('utc_offset', tz);
  }
  troubleNav(clicked=undefined) {
    this.setState({ currentView: "netstat", viewFilter: {dev: clicked}});
  }
  showModalSubscriptionAlert = (title, message, alertType) => {
    console.log('Alert:', message);
    this.setState({subscriptionAlert: true});
    this.setState({modalSubAlertTitle: title});
    this.setState({modalSubAlertMessage: message});
    this.setState({modalSubAlertType: alertType})
  };
  closeModalSubscriptionAlert(show) {
    this.setState({subscriptionAlert: show});
  }
  setSubcriptionStatus(status){
    this.setState({hasActiveSubscription: status});
  }
  async showStripeActivateSubscription(){
    const site = this.props.getActiveSite();
    const ss = new SecondServer(this.props);
    const stripeSessionResponse = await ss.apiInsertData(urlGetStripeSession(siteAccessCode(site)));
    let targeturl = stripeSessionResponse?.data?.data?.result?.message;
    if (targeturl != null){
      console.log('Opening Stripe Session');
      //Type 1 - Replace with the target URL in the same window
      //window.location.href = 'https://www.google.com';

      //Type 2 = Open the targetURL in a new tab
      window.open(targeturl);
    }
  }

  overView() {
    const site = this.props.getActiveSite();
    if (!site || this.state.isLoading) {
      return (
        <div className='ovv-col-container'>
          {this.state.loader}
        </div>
      )}
      if (this.state.needPerms) {
        return(
          <div className="table-container">
            <Popup popupMsg="You don't have permission to view this site"/>
          </div>
        )
      }
      return (
      <>
        <div className="ovv-col-container">
          <SitePane {...this.props} handleUpdate={this.edit} onUpdate={this.specialTZ}/>
          <ContactPane {...this.props} isCellModule={this.state.isCellModule} hasActiveSubscription={this.state.hasActiveSubscription} 
               userIsSubscriberForThisSite={this.state.userIsSubscriberForThisSite}
               subscriptionPastDue={this.state.subscriptionPastDue}
               pushText={this.state.pushText}
               btnLabel={this.state.btnLabel}
               showAlert={this.showModalSubscriptionAlert} 
               setSubcriptionStatus={()=>this.setSubcriptionStatus(true)}
               forceUpd={this.state.forceUpd} streetView={this.state.streetView}/>
          <ReportsPane {...this.props} />
          <DeviceHealthPane {...this.props} forceUpd={this.state.forceUpd}
            perm={this.sitePerms} nav_click={this.troubleNav}
          />
          <ModalSubscriptionAlert show={this.state.subscriptionAlert} hide={()=>this.closeModalSubscriptionAlert(false)} showStripe={()=>this.showStripeActivateSubscription()} title={this.state.modalSubAlertTitle} message={this.state.modalSubAlertMessage} alertType={this.state.modalSubAlertType}/>
        </div>

        <EZNotify message={this.state.bannerMsg} styleName="primary" />
      </>
      
    );
  }

  specialTZ(param) {
    this.updateTzCache(param);
    this.setState({ forceUpd: this.state.forceUpd + 1 });
  }
  edit(event) {
    //console.log (event.target.id, event.target.value)
    let saveObj = {};
    saveObj[event.target.id] = event.target.value;
    const site = this.props.getActiveSite();
    let url = "/tehama/sites/" + siteAccessCode(site);
    if (event.target.id === "address") {
      const deviceId = site.site_details.device_id;
      url = "/tehama/sites/devices/" + deviceId +"?access_code=" + siteAccessCode(site);
    }
    const ss = new SecondServer(this.props);
    ss.apiSaveData(url, saveObj);
  }

  spaRoute (where) {
    this.leftNav({rt: where})
  }
  renderView() {
    const childProps = {spaRoute: this.spaRoute, update: this.state.forceUpd}
    switch (this.state.currentView) {
      default:
      case "overview":
        return <ErrorBoundary>{this.overView()}</ErrorBoundary>
      case "metering":
        //return <DataView component={MeteringReport} props={{...this.props, ...childProps}} 
        //      load={meteringFetch} cache={null}/>   // buggy
        return <ErrorBoundary><MeteringReport {...this.props} {...childProps} /></ErrorBoundary>;
      case "alertset":
        //return (<BatteryReplace {...this.props} />)
        return <ErrorBoundary><AlertSetReport {...this.props} {...childProps} /></ErrorBoundary>
      case "netstat":
        return <ErrorBoundary><Report {...this.props} {...childProps} filter={this.state.viewFilter}/></ErrorBoundary>;
      case "netmap":
        return <Suspense fallback={<div>Loading...</div>}>
                <ErrorBoundary>
                  <VisMapPage {...this.props} {...childProps} />;
                </ErrorBoundary>
              </Suspense>
      case "config":
        return <ErrorBoundary><ConfigSensor {...this.props} {...childProps} /></ErrorBoundary>
      case "measure":
        return <ErrorBoundary><Measure {...this.props} sensor={this.state.pageData} {...childProps} /></ErrorBoundary>
      case "commission":
        return <ErrorBoundary><CommissionSensor {...this.props} {...childProps} /></ErrorBoundary>
      case 'alarmhist':
        return <ErrorBoundary><AlarmHistory {...this.props} {...this.childProps} /></ErrorBoundary>
      //case 'chgsite':
      //  return (<SiteRender {...this.props} />);
    }
  }

  changeSite() {
    this.props.changeSite();
    this.changeView(0);
  }
  // lets one view map to another, pass onChangeView={this.changeView}
  changeView(viewId) {
    const viewName = [
      "chgsite", "overview", "metering", "alertset", "netstat",
      "config", "commission", "measure",
    ];
    if (viewId !== undefined && viewId >= 0 && viewId < viewName.length)
      this.leftNav(viewName[viewId]);
  }
  leftNav(navObj) {
    // Tour code
    this.props.updateSiteLocation(navObj.rt);
    this.props.launchTourStatus(true);
    // End tour code
    this.props.breadCrumb(navObj.rt);
    this.setState({ currentView: navObj.rt, pageData: navObj?.pageData, bannerMsg: "", viewFilter: undefined });
  }
  itemClickHandler(handler) {
    if (!this.isItemActive(handler)) {
      // Analytics.record({name: handler });
      if (permitted(this.sitePerms)) this.leftNav(handler);
      else this.grantModal(true);
    }
  }
  isItemActive(handler) {
    return handler.rt.localeCompare(this.state.currentView) === 0 
           && handler?.pageData === this.state.pageData
  }
  soItem(icon, name, key, handler, margin) {
    const active = this.isItemActive(handler)
    const navbg = active ? "nav-color-active" : "nav-color";
    const itemStyle = active ? "active-li" : "inactive-li";
    const varStyle = {'--indent': margin+'rem', cursor: "pointer"}
    return <li className={"list-group-item d-flex align-items-center nav-padding " + navbg}
        key={key} style={varStyle} onClick={() => this.itemClickHandler(handler)} >
        <FontAwesomeIcon icon={icon} /> &nbsp; <span className={itemStyle}>{name}</span>
      </li>
  }

  dynamicMenu() {
    let menu = [
      {icon: faThLarge, display: "Site Overview", key: "item0", param: {rt: "overview"}, },
      {icon: faMapMarkerAlt, display: "Configuration", key: "item2", param: {rt: "config"}, },
    ]
    const sensors = sensorConfig(this.props.getActiveSite())
    if (Array.isArray(sensors) && sensors.length > 0) {
      sensorDisplayOrder(sensors)
      const sensorMenu2 = sensors.map((s, index) => ({ icon: faCog, display: sensorTypeName(s), 
        key: "sens"+index, param: {rt:"measure", pageData: s}, margin: 2,}))
      menu = menu.concat(sensorMenu2)
    }
    else
      menu = menu.concat({ icon: faCog, display: "Meter Config", key: "item7", 
              param: {rt: "measure"}, margin: 2,})
    menu = menu.concat(
      { icon: faTachometerAlt, display: "Readings", key: "item1", param: {rt: "metering"}, },
      { icon: faTools, display: "Troubleshooting",  key: "item3", param: {rt: "netstat"},  },
      { icon: faExclamationTriangle, display: "Uncommissioned",key: "item5", param: {rt: "commission"},},
      { icon: faProjectDiagram, display: "Network Map", key: "item6", param: {rt: "netmap"}, },
      { icon: faBell, display: "Alert Emails", key: "item4",  param: {rt: "alertset"}, },
      { icon: faSurprise, display: "Alert History", key: "item8", param: {rt: 'alarmhist'}}, 
    )
    return menu
      //      {display: "Device Locations", key: "item5", param:'devLoc'},
 }
  siteOptions() {
    const menuObj = this.dynamicMenu ()
    return (
      <ul className="list-group" key="list-group">
        {menuObj.map((item) =>
          this.soItem(item.icon, item.display, item.key, item.param, item?.margin??1.25)
        )}
      </ul>
    );
  }
  refreshButton() {
    //if (this.state.currentView === "overview") return null;
    return <Button className="refresh-button-div" variant="primary"
        onClick={() => this.setState({ forceUpd: this.state.forceUpd + 1 })}>Refresh</Button>
  }
  grantModal(onOff) {
    let newstate = {grantModal: onOff, bannerMsg: ""}
    if (onOff === false)
      newstate.currentView = "chgsite"
    this.setState({...newstate});
  }

  render() {
    if (this.state.currentView === "chgsite")
      return <SiteRender {...this.props} />;
    return (
      <div className="content-container">
        <GrantRequest {...this.props} show={this.state.grantModal}
            hide={() => this.grantModal(false)} isCellModule={this.state.isCellModule} 
            hasActiveSubscription={this.state.hasActiveSubscription} 
            userIsSubscriberForThisSite={this.state.userIsSubscriberForThisSite} 
            showAlert={this.showModalSubscriptionAlert} 
            setSubcriptionStatus={()=>this.setSubcriptionStatus(true)}/>
        <div className="left-nav-pane">
          <img src="tehama_logo_100p.png" className="nav-logo"
            onClick={() => {window.location.href = "/"; }} alt="Tehama Logo">
          </img>
          <span className="nav-margin" onClick={this.changeSite}>
            <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa-2x"/>
          </span>
          <span className="nav-back" onClick={this.changeSite}>
            Change Site
          </span>
          <div className="vspace">&nbsp;</div>
          <div className="leftnav tour-overview-item1">{this.siteOptions()}</div>
          <div className="vspace">&nbsp;</div>
          {this.refreshButton()}
        </div>
        <div className="main-pane" id="id">
          {this.renderView()}
        </div>
      </div>
    );
  }
}
 